import { dukaanVisitorsCRUDUrl, dukaanVisitorsUrl } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getShopVisitors = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(dukaanVisitorsUrl + "?page_size=50&" + query ?? "", config);

    return response;
};

export const patchShopVisitorsNote = async (id, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(dukaanVisitorsCRUDUrl + "/" + id + "/", data, config);
    return response;
};
